import { Content } from "@/ui";
import { getRoute } from "@/getters/getRoute";
import { createTitle } from "@/functions/createTitle";
import * as additionalComponents from "./__components";
import { simple_pages_helper } from "@/helpers/simple_pages_helper";
import { sortByDate } from "@/functions/sortByDate";

export default function BlogsPage({ content }) {
  return (
    <>
      <Content items={content} additionalComponents={additionalComponents} />
    </>
  );
}

export async function getStaticProps() {
  return {
    props: {
      meta: {
        title: createTitle("Industry Insights"),
        canonical: "https://www.bluearrow.co.uk" + getRoute("industryInsights"),
      },
      content: [
        {
          component: "BreadcrumbNavigation",
          props: {
            items: [
              { label: "Recruitment Solutions", href: "/recruitment-solutions/" },
              { label: "Industry Insights", href: getRoute("industryInsights") },
            ],
          },
        },
        {
          component: "Header",
          props: {
            className: "bg-primary text-white",
            title: {
              path: "page.recruitment-solutions.industry-insights.component.Header.title",
              placeholder: "Industry Insights",
            },
            description: {
              path: "page.recruitment-solutions.industry-insights.component.Header.description",
              placeholder: "",
            },
            img: { path: "page.recruitment-solutions.industry-insights.component.Header.img" },
            variant: "50/50",
          },
        },
        {
          component: "IndustryInsightsFeed",
          props: {
            items: sortByDate(simple_pages_helper.fetch({ parent: "3ac0b752-94d4-49ee-b17a-c45aac2c5eda" }), "published_date"),
          },
        },
      ],
    },
  };
}
